import { getEditorStore } from "../../../domain/store";
import type { SnippetId } from "../../../domain/snippets";

export function insertSectionFromPalette(snippetId: SnippetId): void {
  const { insertSnippet } = getEditorStore();
  insertSnippet(snippetId);
}
